module.exports = __webpack_public_path__ + "img/plataforma-img-02.bc78a89d.jpg";